'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openThreadMessageReceived = undefined;

var _defaultMessageReceived = require('../../actions/defaultMessageReceived');

var openThreadMessageReceived = exports.openThreadMessageReceived = function openThreadMessageReceived(_ref) {
  var message = _ref.message,
      channel = _ref.channel,
      threadId = _ref.threadId;
  return function (dispatch) {
    dispatch((0, _defaultMessageReceived.defaultMessageReceived)(message, channel, threadId));
  };
};